const i18n = {
    en: {
        bytes: 'B',
        kiloBytes: 'KB',
        megaBytes: 'MB',
        gigaBytes: 'GB',
        fax: 'fax',
        months: {
            0: {
                short: 'jan',
                full: 'January',
            },
            1: {
                short: 'feb',
                full: 'February',
            },
            2: {
                short: 'mar',
                full: 'March',
            },
            3: {
                short: 'apr',
                full: 'April',
            },
            4: {
                short: 'may',
                full: 'May',
            },
            5: {
                short: 'june',
                full: 'June',
            },
            6: {
                short: 'july',
                full: 'July',
            },
            7: {
                short: 'aug',
                full: 'August',
            },
            8: {
                short: 'sept',
                full: 'September',
            },
            9: {
                short: 'oct',
                full: 'October',
            },
            10: {
                short: 'nov',
                full: 'November',
            },
            11: {
                short: 'dec',
                full: 'December',
            },
        }
    },
    ru: {
        bytes: 'б',
        kiloBytes: 'кб',
        megaBytes: 'мб',
        gigaBytes: 'гб',
        fax: 'факс',
        months: {
            0: {
                short: 'Янв',
                full: 'Январь',
            },
            1: {
                short: 'Фев',
                full: 'Февраль',
            },
            2: {
                short: 'Мар',
                full: 'Март',
            },
            3: {
                short: 'Апр',
                full: 'Апрель',
            },
            4: {
                short: 'Май',
                full: 'Май',
            },
            5: {
                short: 'Июн',
                full: 'Июнь',
            },
            6: {
                short: 'Июл',
                full: 'Июль',
            },
            7: {
                short: 'Авг',
                full: 'Август',
            },
            8: {
                short: 'Сен',
                full: 'Сентябрь',
            },
            9: {
                short: 'Окт',
                full: 'Октябрь',
            },
            10: {
                short: 'Ноя',
                full: 'Ноябрь',
            },
            11: {
                short: 'Дек',
                full: 'Декабрь',
            },
        }
    },

};

/**
 *
 * @type {string}
 */
const lang = document.documentElement.lang || 'ru';

/**
 * @type {object}
 */
const translations = i18n[lang];

module.exports = {
    i18n,
    lang,
    translations
};



// WEBPACK FOOTER //
// ./js/main/package/i18n.js